import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
// import { DiscordCommunityUrl, AppStoreDownloadUrl, LinkedInUrl, TikTokUrl } from '../assets';

const Footer = () => {
    const { Item, Link } = Nav;

    return (
        <footer className="text-white py-4">
            <Container>
                <Row>
                    <Col md={6}>
                        <p><strong>Memesical</strong></p>
                        <p>3400 Cottage Way, Ste G2 #26808, Sacramento CA 95825</p>
                        <p>Phone: <a href="tel:+17076766189">+1 (707)-676-6189</a></p>
                        <p>Email: <a href="mailto:dongbin@hermic-company.com">dongbin@hermic-company.com</a></p>
                        <p>&copy; 2024 Hermic LLC. All rights reserved.</p>
                    </Col>

                    <Col md={3}>
                        <Nav className="flex-column" activeKey="/home">
                            <Item>
                                <Link href="/" className="footer-link">
                                    Home
                                </Link>
                            </Item>

                            {/* <Item>
                                <Link href={AppStoreDownloadUrl} className="footer-link">
                                    Download
                                </Link>
                            </Item> */}
                        </Nav>
                    </Col>

                    <Col md={3}>
                        <Nav className="flex-column" activeKey="/home">
                            <Item>
                                <Link 
                                    href="https://www.hermic-company.com/memesical-terms" 
                                    className="footer-link">
                                    Terms of Service
                                </Link>
                            </Item>

                            <Item>
                                <Link  
                                    href="https://www.hermic-company.com/memesical-privacy"  
                                    className="footer-link">
                                    Privacy
                                </Link>
                            </Item>
                        </Nav>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export { Footer };
